<svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 8L19.2239 11.9986L15 16" stroke="#6A7285" stroke-width="1.5" stroke-miterlimit="10"/>
<path d="M10 8L14.2239 11.9986L10 16" stroke="#6A7285" stroke-width="1.5" stroke-miterlimit="10"/>
</svg>
